export const setLinkUrl = link => {
    if (!link) {
        return 'javascript:void(0)'
    }
    return link.startsWith('http') ? link : `https://${link}`
}

